import AppProjects from "./projects.vue";

import AppProjectsListRemote from "./projects-list-remote/projects-list-remote.vue";
import AppProjectsListLocal from "./projects-list-local/projects-list-local.vue";
import AppProjectItem from "./project-item/project-item.vue";
import AppProjectsMediasList from "./projects-medias-list/projects-medias-list.vue";
import AppProjectsMediasCreate from "./projects-media-create/projects-media-create.vue";
import AppProjectsMediasUpdate from "./projects-media-update/projects-media-update.vue";

const projectsRoutes = [
  {
    path: "/v2/projects",
    component: AppProjects,
    children: [
      {
        path: "projects-list-remote",
        name: "projects-list-remote",
        component: AppProjectsListRemote
      },

      {
        path: "projects-list-local",
        name: "projects-list-local",
        component: AppProjectsListLocal
      },

      {
        path: ":uuid",
        name: "project-item",
        component: AppProjectItem
      },

      {
        path: ":uuid/medias",
        name: "projects-medias-list",
        component: AppProjectsMediasList
      },

      {
        path: ":uuid/medias/create",
        name: "projects-medias-create",
        component: AppProjectsMediasCreate
      },

      {
        path: ":uuid/medias/update",
        name: "projects-medias-update",
        component: AppProjectsMediasUpdate
      },

      { path: "", redirect: { name: "projects-list-remote" } }
    ]
  }
];

export default projectsRoutes;
